import { useState } from "react";
import useAsyncData from "../../../hooks/use-async-data";
import SearchRoadRoutingRequest from "../../../utils/search-road-route/search-road-routing.request";
import SearchRoadRoutingResponse from "../../../utils/search-road-route/search-road-routing.response";
import searchRoadRoutingService from "../../../utils/search-road-route/search-road-routing.service";
import BillingsRouteDetailsAddress from "../../../../modules/billings/common/route-details/types/billings-route-details-address";

const useBillingsFetchRoute = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<SearchRoadRoutingResponse | null>(null);
  const [address, setAddress] = useState<BillingsRouteDetailsAddress | null>(
    null
  );

  const load = async (
    params: SearchRoadRoutingRequest,
    address: BillingsRouteDetailsAddress
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiFleetPartnerDetails = await searchRoadRoutingService.search(
        params
      );
      setData(taxiFleetPartnerDetails);
      setAddress(address);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
    address,
  };
};

export default useBillingsFetchRoute;
